import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root'})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    private activeRequests = 0;

    show() {
        this.activeRequests++;
        if(this.activeRequests === 1){
            this.loadingSubject.next(true)
        }
    }

    hide(){
        if (this.activeRequests > 0){
            this.activeRequests--;
            if(this.activeRequests === 0){
                this.loadingSubject.next(false)
            }
        }
    }

    reset() {
        this.activeRequests = 0;
        this.loadingSubject.next(false)
    }
}